window.initComplementaryProductsSwiper = function () {
    new Swiper('.complementary-products-wrapper .product-grid', {
        slidesPerView: 1.5,
        spaceBetween: 24,
        breakpoints: {
            568: {
                slidesPerView: 2.5,
                spaceBetween: 10
            }
        }
    });
};
initComplementaryProductsSwiper();

// ------- Cart Drawer Trust Section -------
window.initTrustSwiper = function() {

  const slider = document.querySelector('.trustSwiper');

  if (!slider) return;

  new Swiper(slider, {
    slidesPerView: 1,
    spaceBetween: 10,
    speed: 600,
    loop: false,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    autoplay: {
      delay: 4000,
      disableOnInteraction: false
    },
    breakpoints: {
      480: {
        slidesPerView: 1
      },
      768: {
        slidesPerView: 1
      },
      1024: {
        slidesPerView: 2
      }
    }
  });
}

initTrustSwiper();

window.initMobileSliderArrows = function () {
    const slider = document.querySelector('.mini-cart__navigation');
    const next = document.querySelector('.cart-next');
    const prev = document.querySelector('.cart-prev');

    document.addEventListener("click", function (e) {

    if (e.target.closest(".cart-next")) {
        const slider = document.querySelector(".mini-cart__navigation");

        if (slider) {
        slider.scrollBy({
            left: 300,
            behavior: "smooth"
        });
        }
    }

    if (e.target.closest(".cart-prev")) {
        const slider = document.querySelector(".mini-cart__navigation");

        if (slider) {
        slider.scrollBy({
            left: -300,
            behavior: "smooth"
        });
        }
    }

    });
};
initMobileSliderArrows();